import { render } from "./Product.vue?vue&type=template&id=7f7c3a03"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=7f7c3a03&lang=scss"
script.render = render

export default script